import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { locale as english } from '../i18n/en';
import { locale as french } from '../i18n/fr';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

 import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { AuthenticationService } from '../../../main/authentication/_services/authentication.service';
import { Router } from '@angular/router';
import { User } from '../../../main/_models/User';
import { MatDialog } from '@angular/material/dialog';
import { SendMailComponent } from 'app/main/profile/send-mail/send-mail.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CotisationService } from 'app/main/profile/gestion-cotisation/_services/cotisation.service';
import { Cotisation } from 'app/main/profile/gestion-cotisation/_models/Cotisation';
import { Company } from 'app/main/profile/compagnies/_models/Company';
import { CompagnieService } from 'app/main/profile/compagnies/_services/compagnie.service';
import { Notification, NotificationDto } from './Notification';
import { NotificationService } from './notification-services/notification-services/notification.service';
import { SharedMenuObserverService } from 'app/main/profile/_services/shared-menu-observer.service';
import { DisciplinaryOrder } from 'app/main/profile/users/_models/DisciplinaryOrder';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'fuse-toolbar'
    }
})

export class ToolbarComponent implements OnInit, OnDestroy, AfterViewInit {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    cotisation_url: any = '/profile/cotisation';
    cotisation = null;
    user: User = new User();
    profileImage: string;
    notificationDto: NotificationDto = new NotificationDto();
    cotisations: Cotisation[]=[]
    companyList: Company[] = [];

    // Nouveau: titre et icône dynamiques de la page courante
    pageTitle: string = '';
    pageIcon: string = '';

    // Private
    private _unsubscribeAll: Subject<any>;
    dialogRef: any;
    isDualRole: boolean = false;
    adminMode: boolean = false;
    loadingNotifications: boolean = false;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private translationLoader: FuseTranslationLoaderService,
        private authenticationService: AuthenticationService,
        private router: Router,
        public _matDialog: MatDialog,
        public _snackBar: MatSnackBar,
        private notificationServices: NotificationService,
        private sharedMenuObserverService: SharedMenuObserverService
    ) {
        // Load translations
        this.translationLoader.loadTranslations(english, french);
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'fr',
                title: 'Français',
                flag: 'fr'
            },
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
        ];

        // this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        if(!window.location.pathname.includes('/public'))
        this.authenticationService?.getUserDetails()?.subscribe((user: User) => {
            this.user = user || new User();
            localStorage.setItem('currentUser', JSON.stringify(this.user))
            this.isDualRole = this.authenticationService.hasRole('admin') && this.authenticationService.hasRole('user');
            this.adminMode = this.authenticationService.isAdminMode();
            this.getListNotifications()
            if (this.user && this.user.profileImage) {
                this.profileImage = 'data:image/jpeg;base64,' + this.user.profileImage;
            } else {
                this.profileImage = 'assets/images/avatars/profile.jpg';
            }
            this.cotisation = true
            // Logique pour les stagiaires : si solde < 0, cotisation pas à jour
            if(this.authenticationService.hasRole('ROLE_TRAINEE')){
                if(this.user.solde < 0){
                    this.cotisation = false;
                } else {
                    this.cotisation = true;
                }
            } else {
                // Logique pour les users
            if(this.user.soldeInit < 0 && Object.keys(this.user.soldeCompany).length == 0){
                this.cotisation = false;
            }else if(Object.keys(this.user.soldeCompany).length > 0){
                Object.keys(this.user.soldeCompany).forEach(key => {
                    const companyData = this.user.soldeCompany[key];
                    const companySoldeInit = companyData?.soldeInit ?? companyData;
                    if (companySoldeInit < 0 || this.user.soldeInit < 0) {
                        this.cotisation = false;
                    }
                });
                }
            }
            if(this.user.disciplinaryOrderStatus == 'SUSPENSION')
            authenticationService.getDisciplinaryOrderByUser(this.user.publicId, 'user')
            .subscribe((response: DisciplinaryOrder)=>{
                if(new Date(response.suspensionStartDate) <= new Date() &&new Date() > new Date(response.suspensionEndDate) ){
                    this.onLogout()
                }
            })
            /*Object.keys(this.user.soldeCompany).forEach(key => {
                const value = this.user.soldeCompany[key];
                if (value < 0 || this.user.solde < 0) {
                    this.cotisation = false;
                }
            });*/
        },(error)=>{
            this.onLogout();
        });
    }
    ngAfterViewInit(): void {
        this.sharedMenuObserverService.onCotisationStatus()
        .subscribe((status)=>{
            this.cotisation = status
        });
    }
    
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.translationLoader.loadTranslations(english, french);
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, { id: this._translateService.currentLang });

        // Nouveau: écouter les mises à jour de titre et d’icône
        this.sharedMenuObserverService.onUpdateMenu()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((title: string) => { this.pageTitle = title; });
        this.sharedMenuObserverService.onUpdateIconMenu()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((icon: string) => { this.pageIcon = icon; });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;
        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    onLogout(): void {
         if (
            this.authenticationService.hasRole("ROLE_TRAINEE") ||
            this.authenticationService.hasRoleExternalSupervisor() ||
            this.authenticationService.hasRole("external")
        )
        this.router.navigate(['/auth/trainee/login']);
        else 
        this.router.navigate(['/auth/login']);
        this.authenticationService.logout();

    }

    composeMail():void{
        let title1 = "";
        let title2 = "";
        this._translateService.get('NAVBAR.OPERATIONCANCELED').subscribe((text: string) => { title1 = text })
        this._translateService.get('NAVBAR.CLOSE').subscribe((text: string) => { title2 = text })
        this.dialogRef = this._matDialog.open(SendMailComponent, {
            panelClass: 'app-send-mail',
            width: '75%',
            height: '85%',
        });
        this.dialogRef.afterClosed().subscribe((result: boolean) => {
            if (!result) {
                this._snackBar.open(title1, title2, {
                    duration: 4000,
                });
            }
        });
    }

    getListNotifications(): void {
        if (!this.user?.publicId) { return; }
        this.loadingNotifications = true;
        this.notificationServices.GetListNotifications(this.user.publicId)
            .subscribe((data: NotificationDto) => {
                this.notificationDto.notifications = data?.notifications || [];
                this.notificationDto.count = data?.count || 0;
                this.notificationDto.notifications.forEach((element) => {
                    element.extraInfo = Math.abs(element.extraInfo)
                });
                this.loadingNotifications = false;
            }, _err => {
                this.loadingNotifications = false;
            });
    }

    hasRole(role: string): boolean {
        return this.authenticationService.hasRole(role);
    }

    switchMode(): void {
        if (!this.isDualRole) { return; }
        const next = this.adminMode ? 'user' : 'admin';
        this.authenticationService.setPreferredNavigation(next as 'admin' | 'user');
        this.adminMode = this.authenticationService.isAdminMode();
    }

 navigateTo(notification: Notification, index: number): void{
        if(notification.status == 'NOTCONSULTED' && notification?.publicId)
        this.notificationServices.changeNotificationStatus(notification.publicId).subscribe(()=>{
        this.notificationDto.notifications[index].status = 'CONSULTED';

        })
        switch (notification.typeEntity) {
            case 'INSURANCE':
                this.router.navigate(['/profile/insurance']);
                break;
            case 'COTISATION':
                this.router.navigate(['/profile/cotisation']);
                break;
            case 'USER':
                this.router.navigate(['/profile/users']);
                break;
            case 'COMPANY':
                this.router.navigate(['/profile/company']);
                break;
            case 'STAGE':
                this.navigateToNotification(notification)
        
            default:
                break;
        }
    } 

 
    calcDays(dateNotification: string): string {
        const startDate = new Date(dateNotification);
        const endDate = new Date();
        const timeDiff = endDate.getTime() - startDate.getTime(); // ms difference
      
        const totalSeconds = Math.floor(timeDiff / 1000);
        const totalMinutes = Math.floor(totalSeconds / 60);
        const totalHours   = Math.floor(totalMinutes / 60);
        const totalDays    = Math.floor(totalHours / 24);
      
        // If less than 60 minutes => show minutes
        if (totalMinutes < 60) {
          // Handle the edge case where totalMinutes could be 0
          const minutes = totalMinutes > 0 ? totalMinutes : 0;
          return `il y a ${minutes} min`;
        }
        // If at least 1 hour but less than 24 hours => show hours
        else if (totalHours < 24) {
          return `il y a ${totalHours} h`;
        }
        // If 24 hours or more => show the number of days
        else {
            if (totalDays === 1) {
            return `il y a 1 jour`;
          } else {
            return `il y a ${totalDays} jours`;
          }
        }
      }
    
    


      navigateToNotification(notification: Notification): void {
        notification.status='CONSULTED' ;
        this.notificationDto.count-=1; 
         this.router.navigate(
          ['/profile/trainee/requests'], 
          { queryParams: { folderNumber: notification.extraInfo || null } }
        );
      }
      
      onNotificationsMenuOpened(): void {
        this.getListNotifications();
      }

      markAllAsRead(): void {
        const unread = (this.notificationDto.notifications || []).filter(n => n.status === 'NOTCONSULTED' && n.publicId);
        if (unread.length === 0) { return; }
        forkJoin(unread.map(n => this.notificationServices.changeNotificationStatus(n.publicId))).subscribe(() => {
            this.notificationDto.notifications = this.notificationDto.notifications.map(n => ({ ...n, status: 'CONSULTED' }));
            this.notificationDto.count = 0;
        }, _err => {
            const remaining = (this.notificationDto.notifications || []).filter(n => n.status === 'NOTCONSULTED').length;
            this.notificationDto.count = remaining;
        });
      }

      trackByNotificationId(index: number, notif: Notification): any {
        return notif?.publicId || index;
      }
      
}